<template>
    <div ref="pageContainer" :class="['page-container', currentStyle]" :style="cssVars" @dragover="onDragOver">
        <div ref="pageBg" class="page-bg"></div>
        <div class="page-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageView',
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        cssVars() {
            return {
                '--background-color': this.value.backgroundColor || 'transparent',
                '--background-image': this.value.backgroundImage ? `url(${decodeURIComponent(this.value.backgroundImage)})` : 'none',
                '--padding-x': this.value.paddingX ? this.value.paddingX + 'px' : 0,
            }
        }
    },
    methods: {
        onDragOver(e) {
            e.preventDefault()
            this.$emit('drag-over', e)
        },
    },
}
</script>

<style lang="scss" scoped>
.page-container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.page-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    inset: 0;
    background-image: var(--background-image);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    /* 可选：增强固定效果 */
    z-index: 0;
    pointer-events: none;
    border-radius: 0 0 30px 30px; // 预览时的圆角，正式页面不需要
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        inset: 0;
        background-color: var(--background-color);
    }
}

.page-content {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #dbdbdb;
    }

    &::-webkit-scrollbar-track {
        background: #f6f6f6;
    }
}
</style>
